/**
 * 同步状态上下文
 *
 * 提供重试连接和离线使用的回调函数，供 SyncStatusIndicator 使用
 */

import React, { createContext, useContext, useCallback } from 'react'

interface SyncStatusContextValue {
  onRetry?: () => void
  onUseOffline?: () => void
}

const SyncStatusContext = createContext<SyncStatusContextValue>({})

export const SyncStatusProvider: React.FC<{
  onRetry?: () => void
  onUseOffline?: () => void
  children: React.ReactNode
}> = ({ onRetry, onUseOffline, children }) => {
  const handleRetry = useCallback(() => {
    onRetry?.()
  }, [onRetry])

  const handleUseOffline = useCallback(() => {
    onUseOffline?.()
  }, [onUseOffline])

  return (
    <SyncStatusContext.Provider value={{ onRetry: handleRetry, onUseOffline: handleUseOffline }}>
      {children}
    </SyncStatusContext.Provider>
  )
}

export const useSyncStatusContext = () => {
  return useContext(SyncStatusContext)
}

export default SyncStatusContext
